import React, { FC } from "react";
import { Cell, Pie, PieChart, Tooltip } from "recharts";
import { DraggableProvided } from "react-beautiful-dnd";
import { MdDragHandle } from "react-icons/md";

type Card = {
  [key: string]: string;
};

interface Props {
  provided: DraggableProvided;
  colors: string[];
  percentFillValue: number;
  cardInfo: Card;
  card: any;
}

const AreaCard: FC<Props> = ({
  cardInfo,
  provided,
  percentFillValue,
  colors,
  card,
}) => {
  const filledValue = (percentFillValue / 100) * 360;
  const remainedValue = 360 - filledValue;

  const data = [
    { name: "Remained", value: remainedValue },
    { name: "Achieved Sales", value: filledValue },
  ];

  const renderTooltipContent = (value: number) => {
    return `${(value / 360) * 100} %`;
  };

  return (
    <div
      className="area-card"
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
    >
      <div className="container">
        <div className="area-card-info">
          <h5 className="info-title">{cardInfo.title}</h5>
          <div className="info-value">{cardInfo.value}</div>
          <p className="info-text">{cardInfo.text}</p>
        </div>
        <div className="area-card-chart">
          <PieChart width={100} height={100}>
            <Pie
              data={data}
              cx={50}
              cy={45}
              innerRadius={20}
              fill="#e4e8ef"
              paddingAngle={0}
              dataKey="value"
              startAngle={-270}
              endAngle={150}
              stroke="none"
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Pie>
            <Tooltip formatter={renderTooltipContent} />
          </PieChart>
        </div>
      </div>
      <div className="drag-icon">
        <MdDragHandle />
      </div>
    </div>
  );
};

export default AreaCard;
